<div class="dialog-wrapper">
  <div class="warning-header">
    <div class="header-left">
      <div class="icon-circle">
        <mat-icon>warning</mat-icon>
      </div>
      <div class="title-area">
        <h2 mat-dialog-title>
          {{ 'createDoc.overwriteDialog.title' | transloco }}
        </h2>
      </div>
    </div>
    <button mat-icon-button color="primary" (click)="onCancel()" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p class="description-text">
      {{ 'createDoc.overwriteDialog.description' | transloco: { documentType: documentTypeLabel, language: languageName, count: affectedCount } }}
    </p>

    <h3 class="list-title">
      {{ 'createDoc.overwriteDialog.listTitle' | transloco }}
    </h3>

    <div class="affected-container">
      <div class="table-header">
        <span class="col-id">
          {{ 'createDoc.failedDialog.tableHeaderId' | transloco }}
        </span>
      </div>
      <div class="table-body">
        <div *ngFor="let entry of data.affectedEntries" class="table-row">
          <div class="col-id">
            <span class="id-badge">{{ entry.id }}</span>
          </div>
          <div class="col-action">
            <a
              mat-button
              color="primary"
              [routerLink]="[data.isPackagingSystem ? '/cockpit/packaging/packaging-system/update' : '/cockpit/packaging/packaging-unit/update', entry.id]"
              target="_blank"
              class="open-tab-btn">
              <mat-icon>open_in_new</mat-icon>
              <span>{{ 'createDoc.failedDialog.openInNewTab' | transloco }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="summary-line">
      <strong>{{ affectedCount }} {{ 'createDoc.failedDialog.of' | transloco }} {{ data.totalCount }}</strong>
      {{ 'createDoc.overwriteDialog.summaryOverwritten' | transloco }}
      &nbsp;•&nbsp;
      <span class="missing-text">{{ missingCount }} {{ 'createDoc.overwriteDialog.summaryMissing' | transloco }}</span>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button mat-stroked-button (click)="onCancel()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button
      mat-stroked-button
      color="primary"
      [disabled]="missingCount === 0"
      (click)="onCreateMissing()"
      matTooltip="{{ 'createDoc.overwriteDialog.createMissingTooltip' | transloco }}">
      {{ 'createDoc.overwriteDialog.createMissingButton' | transloco }}
    </button>
    <button mat-raised-button color="primary" (click)="onCreateAll()">
      {{ 'createDoc.overwriteDialog.createAllButton' | transloco }}
    </button>
  </mat-dialog-actions>
</div>
